export const CODIGO_ESTABLECIMIENTO_NO_AUTORIZADO = 'ESTABLECIMIENTO_NO_AUTORIZADO';

export const EVENTO_ESTABLECIMIENTO_NO_AUTORIZADO = 'senciyo:establecimiento-no-autorizado';
